import React, { useState, useEffect } from "react";
import axios from "axios"
import Navbar from "components/Navbar";

const apiUrl = process.env.REACT_APP_API_URL;

const UserApproval = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshDB, setRefreshDB] = useState(false);

  const fetchDataFromBackend = async () => {
    const token = sessionStorage.getItem('token');
    try {
      const response = await axios.post(`${apiUrl}/user_approval/data`, {},
        {
          params: {
            token
          },
          headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await fetchDataFromBackend();
        setData(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [refreshDB]);

  

  // Function to handle bulk updates
  const handleUpdate = async () => {
    const token = sessionStorage.getItem('token');

    const updates = data? data.filter(row => row.selected)
    .map(row => ({user_id: row.user_id, approval: row.approval, role: row.role})): [];

    try {
      await axios.post(`${apiUrl}/user_approval/update`, {updates},
        {
          params: {
            token
          },
          headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      setRefreshDB(!refreshDB)
      console.log("Updated data:", updates);
      alert("All changes have been updated!");
    } catch(error) {
      console.error('Error update data:', error);
    }
    

    
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <div className="relative bg-gray-900_01 w-full min-h-screen p-5">
      {/* Navbar */}
      <Navbar />

      {/* Table Header */}
      <div className="flex justify-between items-center my-4">
        <h1 className="text-[24px] font-bold text-white-a700">User Approval</h1>
      </div>

      {/* Table */}
      {data.length === 0 ? (
        <p className="text-white-a700">No data available</p>
      ) : (
        <div>
          <table className="w-full bg-gray-900 text-white-a700 border-collapse border border-gray-700">
            <thead className="bg-gray-800">
              <tr>
                <th className="border border-gray-700 p-2">Select</th>
                <th className="border border-gray-700 p-2">User ID</th>
                <th className="border border-gray-700 p-2">Username</th>
                <th className="border border-gray-700 p-2">Email</th>
                <th className="border border-gray-700 p-2">Approval</th>
                <th className="border border-gray-700 p-2">Role</th>
                <th className="border border-gray-700 p-2">Client ID</th>
                <th className="border border-gray-700 p-2">Create Date</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row) => (
                <tr
                  key={row.user_id}
                  className="odd:bg-gray-700 even:bg-gray-800"
                >
                  <td className="border border-gray-700 p-2">
                    <input 
                      type="checkbox"
                      checked={row.selected || false }
                      onChange={(e) =>
                        setData((prev) =>
                          prev.map((item) =>
                            item.user_id === row.user_id
                              ? { ...item, selected: e.target.checked }
                              : item
                          )
                        )
                      }

                    />
                  </td>
                  <td className="border border-gray-700 p-2">{row.user_id}</td>
                  <td className="border border-gray-700 p-2">{row.username}</td>
                  <td className="border border-gray-700 p-2">{row.email}</td>
                  <td className="border border-gray-700 p-2">
                    <select
                      value={row.approval}
                      onChange={(e) =>
                        setData((prev) =>
                          prev.map((item) =>
                            item.user_id === row.user_id
                              ? { ...item, approval: e.target.value, selected: true }
                              : item
                          )
                        )
                      }
                      className="bg-gray-800 border rounded px-2 py-1 text-white"
                    >
                      <option value="pending">Pending</option>
                      <option value="active">Active</option>
                      <option value="revoked">Revoked</option>
                    </select>
                  </td>
                  <td className="border border-gray-700 p-2">
                    <select
                      value={row.role}
                      onChange={(e) =>
                        setData((prev) =>
                          prev.map((item) =>
                            item.user_id === row.user_id
                              ? { ...item, role: e.target.value, selected: true }
                              : item
                          )
                        )
                      }
                      className="bg-gray-800 border rounded px-2 py-1 text-white"
                    >
                      <option value="user">User</option>
                      <option value="admin">Admin</option>
                      <option value="superadmin">SuperAdmin</option>
                      <option value="support">Support</option>
                    </select>
                  </td>
                  <td className="border border-gray-700 p-2">{row.client_id}</td>
                  <td className="border border-gray-700 p-2">
                    {new Date(row.create_date).toLocaleDateString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Update Button */}
          <div className="flex justify-end mt-4">
            <button
              onClick={handleUpdate}
              className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-500"
            >
              Update
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserApproval;
